export const pricingRulesRouter = [
  {
    path: "/pricing-rules",
    name: "pricing-rules",
    component: () => import("../pages/pricing-rules/PricingRules.vue"),
    meta: {
      text: "$vuetify.layout.navigationSidebar.pricingRules",
    },
  },
  {
    path: "/pricing-rules/create",
    name: "pricing-rules-create",
    component: () => import("../pages/pricing-rules/CreatePricingRule.vue"),
    meta: {
      text: "$vuetify.layout.navigationSidebar.createPricingRule",
      parent: {
        name: "$vuetify.layout.navigationSidebar.pricingRules",
        disabled: false,
        path: "/pricing-rules",
        exact: true,
      },
    },
  },
  {
    path: "/pricing-rules/edit/:id",
    name: "pricing-rules-edit",
    component: () => import("../pages/pricing-rules/EditPricingRule.vue"),
    meta: {
      text: "$vuetify.layout.navigationSidebar.editPricingRule",
      parent: {
        name: "$vuetify.layout.navigationSidebar.pricingRules",
        disabled: false,
        path: "/pricing-rules",
        exact: true,
      },
    },
  },
  {
    path: "/pricing-rules/price-change-history",
    name: "price-change-history",
    component: () => import("../pages/pricing-rules/PriceChangeHistory.vue"),
    meta: {
      text: "$vuetify.layout.navigationSidebar.priceChangeHistory",
      parent: {
        name: "$vuetify.layout.navigationSidebar.pricingRules",
        disabled: false,
        path: "/pricing-rules",
        exact: true,
      },
    },
  },
];
